import { StanTable } from '@/components';
import { AudienceTableProps } from '../../types/audience.types';

export const AudienceTable = ({
    fans,
    recipientCount,
    currentPage,
    totalPages,
    isLoading,
    onPageChange,
}: AudienceTableProps) => {
    return (
        <StanTable
            columns={[
                {
                    header: 'Name',
                    accessorKey: 'name',
                    cell: info => info.getValue(),
                },
                {
                    header: 'Email',
                    accessorKey: 'email',
                    cell: info => info.getValue(),
                },
            ]}
            data={fans}
            isLoading={isLoading}
            page={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            totalRowsLabel={
                <span className='text-label-sm-bold text-brand-main'>{recipientCount} recipients selected</span>
            }
        />
    );
};
